import React from 'react';
import { MessageCircle } from 'lucide-react';

const PHONE = '918860553236';
const MSG = encodeURIComponent("Hi Wrap Your Wish! I'd like a hamper quote please.");

const WhatsAppFloat = () => (
  <a
    href={`https://wa.me/${PHONE}?text=${MSG}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    title="Chat on WhatsApp"
    className="fixed bottom-5 right-5 z-[60] group flex items-center justify-center"
  >
    <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-35 animate-ping pointer-events-none" />
    <span className="relative flex items-center justify-center w-12 h-12 bg-[#25D366] text-white rounded-full shadow-lg hover:shadow-xl hover:bg-[#128C7E] hover:scale-105 active:scale-95 transition-all duration-200">
      <svg viewBox="0 0 32 32" width="22" height="22" fill="currentColor" aria-hidden="true">
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.35 3.045 4.409 3.876.372.143.876.316 1.263.416.43.13.816.115 1.16.115.517 0 1.247-.573 1.462-.99.187-.343.187-.746.09-1.062-.13-.373-.372-.53-.6-.658-.216-.116-1.06-.508-1.23-.508zM16.026 4.5c-6.318 0-11.5 5.181-11.5 11.499a11.4 11.4 0 0 0 1.635 5.881l-1.03 3.75 3.855-1.011a11.49 11.49 0 0 0 5.04 1.166c6.319 0 11.5-5.181 11.5-11.5S22.343 4.5 16.026 4.5z"/>
      </svg>
    </span>
  </a>
);

export default WhatsAppFloat;
